import { Link } from 'react-router';
import './style.scss';

type ButtonColor = 'red' | 'blue' | 'transparent-blue' | 'transparent-red';
type ButtonSize = 'default' | 'small';

interface IProps {
  href?: string | null;
  disabled?: boolean;
  size?: ButtonSize;
  color?: ButtonColor;
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

function Button(props: IProps) {
  const handleClick = () => {
    if (!props.disabled) {
      props.onClick?.();
    }
  };

  if (props.onClick != null && props.href != null) {
    throw new Error('Button must has only href or only onClick attribute');
  }

  if (props.href != null) {
    return (
      <Link
        className={createClassName(props)}
        to={props.href}
      >
        {props.children}
      </Link>
    );
  }

  return (
    <div
      className={createClassName(props)}
      onClick={handleClick}
    >
      {props.children}
    </div>
  );
}

function getPropsSizeClass(size: ButtonSize | null | undefined): string {
  switch (size) {
    case null:
    case undefined:
    case 'default':
      return 'd-M4s';

    case 'small':
      return 's-uHd';

    default:
      throw new Error('Unexpected button size: ' + size);
  }
}

function getPropsColorClass(color: ButtonColor | null | undefined): string {
  switch (color) {
    case null:
    case undefined:
    case 'blue':
      return 'btn-b-6Ye';

    case 'red':
      return 'btn-r-Nsh';

    case 'transparent-blue':
      return 'btn-tb-iEy';
    case 'transparent-red':
      return 'btn-tr-7jS';

    default:
      throw new Error('Unexpected button color: ' + color);
  }
}

function createClassName(props: IProps): string {
  const parts = ['btn-6jo3'];
  parts.push(getPropsSizeClass(props.size));
  parts.push(getPropsColorClass(props.color));

  if (props.disabled === true) {
    parts.push('btn-d-mNsj');
  }

  if (props.className != null) {
    parts.push(props.className);
  }

  return parts.join(' ');
}

export default Button;
